module.exports = __webpack_public_path__ + "static/img/logo_interflora.3886bb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_interflora.svg
// module id = 468
// module chunks = 1